// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".table-message{margin:auto;text-align:center}", "",{"version":3,"sources":["webpack://app/containers/disputes/components/table-message/style.css"],"names":[],"mappings":"AAAA,eACE,WAAY,CACZ,iBACF","sourcesContent":[".table-message {\n  margin: auto;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
